let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("a5lMy")).then(() => parcelRequire('lE6mu'));